import PivotChart from './PivotChart';

export default PivotChart;
